import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import {
    MatSidenavModule,
    MatListModule,
    MatTooltipModule,
    MatOptionModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE
} from '@angular/material';

// ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT
import { HeaderTopComponent } from './components/header-top/header-top.component';
import { SidebarTopComponent } from './components/sidebar-top/sidebar-top.component';

// ALL TIME REQUIRED
import { AdminLayoutComponent } from './components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './components/layouts/auth-layout/auth-layout.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { AppComfirmComponent } from './services/app-confirm/app-confirm.component';
import { AppLoaderComponent } from './services/app-loader/app-loader.component';

// DIRECTIVES
import { FontSizeDirective } from './directives/font-size.directive';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { AppDropdownDirective } from './directives/dropdown.directive';
import { DropdownAnchorDirective } from './directives/dropdown-anchor.directive';
import { DropdownLinkDirective } from './directives/dropdown-link.directive';
import { EgretSideNavToggleDirective } from './directives/egret-side-nav-toggle.directive';

// PIPES
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { ExcerptPipe } from './pipes/excerpt.pipe';
import { DatediffPipe } from './pipes/datediff.pipe';

// SERVICES
import { ThemeService } from './services/theme.service';
import { LayoutService } from './services/layout.service';
import { NavigationService } from './services/navigation.service';
import { RoutePartsService } from './services/route-parts.service';
import { AuthGuard } from './services/auth/auth.guard';
import { AppConfirmService } from './services/app-confirm/app-confirm.service';
import { AppLoaderService } from './services/app-loader/app-loader.service';
import { UserProfileApi } from './services/sdk/services/custom';

// COMPONENTS
import {MomentUtcDateAdapter} from '../utc-date-adapter';
import {MAT_MOMENT_DATE_FORMATS} from "@angular/material-moment-adapter";
import {ChargeMeterReadingsComponent} from '../views/rentals/properties/property/units/meter-readings/charge/charge.component';
import {CancelInvoiceComponent} from '../views/leases/lease/lease-financials/lease-invoices/cancel-invoice/cancel-invoice.component';
import {CancelPropertyBillComponent} from '../views/accounting/bills/cancel-property-bill/cancel-property-bill.component';
import {CollectCommissionComponent} from 'app/views/accounting/company-accounts/company-cash/collect-commission/collect-commission.component';

// VALIDATORS

/*
  Only Required if you want to use Angular Landing
  (https://themeforest.net/item/angular-landing-material-design-angular-app-landing-page/21198258)
*/
// import { LandingPageService } from '../shared/services/landing-page.service';


export const MY_FORMATS = {
    parse: {
        dateInput: {month: 'short', year: 'numeric', day: 'numeric'},
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'DD',
        monthYearA11yLabel: 'MM YYYY',
    },
};

const classesToInclude = [
    HeaderTopComponent,
    SidebarTopComponent,
    SidenavComponent,
    NotificationsComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    BreadcrumbComponent,
    AppComfirmComponent,
    AppLoaderComponent,
    FontSizeDirective,
    ScrollToDirective,
    AppDropdownDirective,
    DropdownAnchorDirective,
    DropdownLinkDirective,
    EgretSideNavToggleDirective,
    RelativeTimePipe,
    ExcerptPipe,
    DatediffPipe,
    ChargeMeterReadingsComponent,
    CancelInvoiceComponent,
    CancelPropertyBillComponent,
    CollectCommissionComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FlexLayoutModule,
        TranslateModule,
        MatSidenavModule,
        MatListModule,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
        MatMenuModule,
        MatSnackBarModule,
        MatGridListModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatRadioModule,
        MatCheckboxModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatRippleModule,
        MatDialogModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        NgxPermissionsModule.forChild()
    ],
    entryComponents: [
        AppComfirmComponent,
        AppLoaderComponent,
        ChargeMeterReadingsComponent,
        CancelInvoiceComponent,
        CancelPropertyBillComponent,
        CollectCommissionComponent
    ],
    providers: [
        ThemeService,
        LayoutService,
        NavigationService,
        RoutePartsService,
        AuthGuard,
        AppConfirmService,
        AppLoaderService,
        UserProfileApi,
         { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
         {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
         { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        // LandingPageService
    ],
    declarations: classesToInclude,
    exports: classesToInclude
})
export class SharedModule {}


